import { clientConfig } from "../config/client";

export default defineAppConfig({
  layer: {
    name: "AP-006",
  },
  ui: {
    colors: {
      primary: "obscura",
      neutral: "zinc",
    },

    toast: {
      slots: {
        title: "font-semibold text-base md:text-base",
        description: "font-normal text-neutral-100 md:text-sm",
        icon: "size-6",
      },
    },

    button: {
      slots: {
        base: "h-fit",
      },
      variants: {
        variant: {
          glass: "data-[active=true]:bg-white/20 data-[active=true]:text-white",
          glow: "data-[active=true]:bg-white/20 data-[active=true]:text-white",
        },
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class: "text-primary-950 bg-primary-50 hover:bg-white active:bg-primary-100 disabled:bg-primary-50 aria-disabled:bg-primary-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        },
        {
          color: "primary",
          variant: "soft",
          class: "text-white bg-white/12 ring ring-inset ring-white/25 hover:bg-white/18 active:bg-white/20 disabled:bg-white/10 aria-disabled:bg-white/10 backdrop-blur-md focus-visible:bg-white/18 focus-visible:text-white focus:outline-none data-[active=true]:bg-white/20 data-[active=true]:text-white",
        },
        {
          color: "primary",
          variant: "link",
          class: "underline text-default hover:text-default/75 active:text-default/75 disabled:text-default aria-disabled:text-default focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary",
        },
        {
          color: "primary",
          variant: "outline",
          class: "ring ring-inset ring-white/30 text-white hover:bg-white/10 active:bg-white/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-200",
        },
        {
          color: "primary",
          variant: "subtle",
          class: "text-white ring ring-inset ring-white/20 bg-white/10 hover:bg-white/15 active:bg-white/15 disabled:bg-white/10 aria-disabled:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-200",
        },

        // variant glass
        {
          color: "primary",
          variant: "glass",
          class: {
            base: "ap-006-glass-button rounded-md!",
            leadingIcon: "size-4 min-w-4 min-h-4",
            trailingIcon: "size-4 min-w-4 min-h-4",
          },
        },
        {
          color: "primary",
          variant: "glow",
          class: {
            base: "ap-006-glow-button rounded-md!",
            leadingIcon: "size-4 min-w-4 min-h-4",
            trailingIcon: "size-4 min-w-4 min-h-4",
          },
        },
      ],
    },

    alert: {
      compoundVariants: [
        {
          color: "primary",
          variant: "subtle",
          class: {
            root: "bg-white/10 text-white ring ring-inset ring-white/20 backdrop-blur-md",
          },
        },
      ],
    },
  },
  template: clientConfig.template,
});
